import React, { useState, useEffect } from 'react';
import { withStyles, styled } from "@mui/styles";
import { Grid, Tab, Tabs } from '@mui/material';

// import TranslateCode from './TranslateCode';
import Policies from './Policies';
import Refund_policy from './Refund_policy';
import Obligations from './Obligations';
import Cdsl from './Cdsl';
import Bsda from './bsda';
import { useLanguage } from "../../Context/LangContext";
import { useLocation } from "react-router-dom";
const StyledTabs = styled(Tab)({
    '&.Mui-selected': {
        fontFamily: 'Inter500 !important',
    },
});

const styles = theme => ({
    buttonlabel: {
        textTransform: 'none !important',
        color: '#000000 !important',
        fontFamily: 'Inter400 !important',
        fontSize: 'calc(15px + var(--font-delta)) !important',
        "&:hover": {
            cursor: 'pointer'
        },
        "@media only screen and (max-device-width: 700px)": {
            fontSize: 'calc(14px + var(--font-delta)) !important',
            width: "150px !important"
        },

    },
    buttonlabel_bold: {
        textTransform: 'none !important',
        color: '#000000 !important',
        fontFamily: 'Inter700',
        fontSize: 'calc(15px + var(--font-delta)) !important',
        fontWeight: '600 !important'
    },
    buttonlabel_bold1: {
        color: '#000000 !important',
        fontFamily: 'Inter700',
        fontSize: 'calc(15px + var(--font-delta)) !important',
        fontWeight: '600 !important',
        "&:hover": {
            color: "#00ACFE !important",
            cursor: 'pointer'
        },
    },
    p_card: {
        width: '90%',
        "@media only screen and (max-device-width: 480px)": {
            width: '100%',
        }
    },
    p_tab_back: {
        background: '#F7F9FA !important',
        "@media only screen and (max-device-width: 480px)": {
            background: '#F7F9FA !important',
            '& .MuiTabs-scrollButtons': {
                color: 'white !important',
            },
        },
    },
    p_tab_back1: {
        background: '#ffffff',
        height: 'auto',
        padding: '32px',
        borderRadius: '8px',
        marginTop: '15px',
        "@media only screen and (max-device-width: 480px)": {
            background: '#F7F9FA !important',
            borderRadius: '0px',
            paddingTop: '15px'
        }
    },
    main_tab: {
        "@media only screen and (max-device-width: 480px)": {
            paddingTop: '90px !important',
            height: 'auto',
        }
    }
});

const PrivacyPoliciesMain = ({ classes }) => {
    const [tabvalue, setTabvalue] = useState(0);
    const [selectedLanguage, setSelectedLanguage] = useState(false);
    const [isTabReady, setIsTabReady] = useState(false);
    const location = useLocation();

    // useEffect(() => {
    //     document.body.style.backgroundColor = "#F2F2F2";
    //     if (window.innerWidth < 960) {
    //         document.body.style.backgroundColor = "#F2F2F2 !important";
    //     }

    //     if (window.location.pathname === "/Privacy_Policy") {
    //         setTabvalue(0);
    //     }
    //     if (window.location.pathname === "/refund_policy") {
    //         setTabvalue(1);
    //     }
    //     if (window.location.pathname === "/termsandconditions") {
    //         setTabvalue(2);
    //     }
    //     if (window.location.pathname === "/cdsl") {
    //         setTabvalue(3);
    //     }
    //     if (window.location.pathname === "/bsda") {
    //         setTabvalue(4);
    //     }
    //     if (window.location.pathname === "/risk_disclosure") {
    //         setTabvalue(2);
    //         setIsTabReady(true); // Mark that we need to scroll after render
    //     }
    // }, []);

    useEffect(() => {
        // Set background color
        document.body.style.backgroundColor = "#F2F2F2";
        if (window.innerWidth < 960) {
            document.body.style.backgroundColor = "#F2F2F2";
        }

        // Update tab value based on current route
        switch (location.pathname) {
            case "/Privacy_Policy":
                setTabvalue(0);
                break;
            case "/refund_policy":
                setTabvalue(1);
                break;
            case "/termsandconditions":
                setTabvalue(2);
                break;
            case "/cdsl":
                setTabvalue(3);
                break;
            case "/bsda":
                setTabvalue(4);
                break;
            case "/risk_disclosure":
                setTabvalue(2);
                setIsTabReady(true); // Mark that we need to scroll after render
                break;
            default:
                setTabvalue(0);
                break;
        }


        if (location.pathname !== "/risk_disclosure") {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }

    }, [location.pathname]);
      // Remove the else block that was trying to scroll unconditionally

      // This effect runs after tab content has rendered
    useEffect(() => {
        if (isTabReady) {
            const element = document.getElementById('risk-disclosure-content');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
            setIsTabReady(false); // Reset the flag
        }
    }, [isTabReady, tabvalue]); // Runs when tab changes or when we set isTabReady



    const handleTabChange = (event, value) => {
        setTabvalue(value);
    };

    const handleSelectedLanguage = (value) => {
        setSelectedLanguage(value);
    };

    const { language } = useLanguage();
    const tabLabels = {
        en: {
            privacyPolicy: "Privacy Policy",
            refundPolicy: "Refund Policy",
            rightsObligations: "Rights & Obligations (Terms and Conditions)",
            rightsObligationsCds: "Rights & Obligations - CDSL",
            bsda: "BSDA",
        },
        hi: {
            privacyPolicy: "गोपनीयता नीति",
            refundPolicy: "रिफंड नीति",
            rightsObligations: "अधिकार और दायित्व (नियम और शर्तें)",
            rightsObligationsCds: "अधिकार और दायित्व - CDSL",
            bsda: "बीएसडीए",
        },
        kn: {
            privacyPolicy: "ಗೌಪ್ಯತಾ ನೀತಿ",
            refundPolicy: "ರಿಫಂಡ್ ನೀತಿ",
            rightsObligations: "ಹಕ್ಕುಗಳು ಮತ್ತು ಬಾಧ್ಯತೆಗಳು (ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು)",
            rightsObligationsCds: "ಹಕ್ಕುಗಳು ಮತ್ತು ಬಾಧ್ಯತೆಗಳು - CDSL",
            bsda: "ಬಿಎಸ್‌ಡಿಎ",
        },
        ma: {
            privacyPolicy: "गोपनीयता धोरण",
            refundPolicy: "परतावा धोरण",
            rightsObligations: "हक्क आणि जबाबदाऱ्या (नियम व अटी)",
            rightsObligationsCds: "हक्क आणि जबाबदाऱ्या - CDSL",
            bsda: "बीएसडीए",
        },
        gu: {
            privacyPolicy: "ગોપનીયતા નીતિ",
            refundPolicy: "રિફંડ નીતિ",
            rightsObligations: "હકો અને ફરજો (નિયમો અને શરતો)",
            rightsObligationsCds: "હકો અને ફરજો - CDSL",
            bsda: "બીએસડીએ",
        },
    };


    return (
        <div className={classes.main_tab} style={{ paddingTop: selectedLanguage ? '70px' : '140px', height: 'auto' }}>
            <Grid>
                {/* <TranslateCode handleSelectedLanguage={handleSelectedLanguage} /> */}
            </Grid>

            <Grid style={{ width: '100%', display: 'flex', justifyContent: 'center', paddingBottom: '30px' }}>
                <Grid className={classes.p_card}>
                    <Tabs
                        variant="scrollable"
                        scrollButtons="auto"
                        allowScrollButtonsMobile
                        value={tabvalue}
                        onChange={handleTabChange}
                        sx={{ overflowX: "auto !important" }}
                        className={classes.p_tab_back}
                        TabIndicatorProps={{
                            style: {
                                backgroundColor: "#F3D45E"
                            }
                        }}
                    >
                        <StyledTabs sx={{ width: "17.5%" }} className={classes.buttonlabel} label={tabLabels[language].privacyPolicy} />
                        <StyledTabs sx={{ width: "17.5%" }} className={classes.buttonlabel} label={tabLabels[language].refundPolicy} />
                        <StyledTabs sx={{ width: "25%" }} className={classes.buttonlabel} label={tabLabels[language].rightsObligations} />
                        <StyledTabs sx={{ width: "25%" }} className={classes.buttonlabel} label={tabLabels[language].rightsObligationsCds} />
                        <StyledTabs sx={{ width: "15%" }} className={classes.buttonlabel} label={tabLabels[language].bsda} />
                    </Tabs>

                    {tabvalue === 0 &&
                        <div className={classes.p_tab_back1}>
                            <Policies />
                        </div>
                    }
                    {tabvalue === 1 &&
                        <main className={classes.p_tab_back1}>
                            <Refund_policy />
                        </main>
                    }
                    {tabvalue === 2 &&
                        <main className={classes.p_tab_back1}>
                            <Obligations />
                        </main>
                    }
                    {tabvalue === 3 &&
                        <main className={classes.p_tab_back1}>
                            <Cdsl/>
                        </main>
                    }
                    {tabvalue === 4 &&
                        <main className={classes.p_tab_back1}>
                            <Bsda/>
                        </main>
                    }
                </Grid>
            </Grid>

        </div>
    );
};

export default withStyles(styles)(PrivacyPoliciesMain);